import { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';

const DashboardColumnChart = () => {

    const [selected, setSelected] = useState(1);
    const [loading, setLoading] = useState(false);

    const [series, setSeries] = useState([{
        data: [0, 0, 0, 0, 0, 0, 0]

    }]);

    const [options, setOptions] = useState({
        chart: {
            height: 350,
            type: 'area',
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false,
                allowMouseWheelZoom: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        }, fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 1,
                opacityTo: 0,
                gradientToColors: ["white"],
                stops: [0, 100]
            }
        },
        xaxis: {
            type: 'datetime',
            categories: [],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy'
            }, y: {
                formatter: undefined,
                title: {
                    formatter: (seriesName) => 'Total',
                },
            },
        },
        grid: {
            strokeDashArray: 6,
            column: {
                colors: undefined,
                opacity: 0.1
            },
        }
    })

    async function getGraphData() {
        setLoading(true);
        let tempArr = [];
        let tempArrX = [];
        let resp = await getApi(urlApi.topPerformGraphData + selected);
        if (resp.responseCode === 200) {
            for (const item of resp.data) {
                tempArr.push(item?.count);
                tempArrX.push(item?.date);
            }
            setSeries([{
                data: tempArr
            }]);
            setOptions({ ...options, xaxis: { ...options.xaxis, categories: tempArrX } });
        }
        setLoading(false);
    }

    useEffect(() => {
        getGraphData();
    }, [selected])

    return (
        <div className='bg-white p-1.5 rounded-xl h-full'>
            <div className="flex justify-between items-center p-1 gap-2">
                <div>
                    <p className='mb-0 text-md font-bold text-[var(--grey)]'>Here is your unique clicks analytics </p>
                    <p className='text-sm font-medium text-[var(--secondary-text)]'>Clicks + Scan Over Time</p>
                </div>
                <div className='flex ms-auto gap-2'>
                    <select name="" id="" className='form-control form-control-sm' onChange={(e) => setSelected(e.target.value)}>
                        <option value="1">Links</option>
                        <option value="2">QR Codes</option>
                        <option value="3">Pages</option>
                        <option value="5">Business Cards</option>
                    </select>
                </div>
            </div>
            {loading ? "Loading..." : <Chart options={options} series={series} height={'90%'} type="area" />}
        </div>
    )
}

export default DashboardColumnChart

const SelectableCard = ({ title, value, index, defaultSelected }) => {
    return (
        <div className={`flex items-center gap-2 justify-between ${index == defaultSelected ? 'bg-[var(--primary)]' : 'bg-[var(--deselect-btn-bg)]'} px-3 py-2.5 rounded-xl cursor-pointer`} >
            <div>
                <p className='text-sm font-normal mb-[4px]'>{title}</p>
                <p className='text-lg font-semibold mb-0'>{value}</p>
            </div>
            <input type='radio' className='radio-btn' name='selectable-radio' value={index} checked={index == defaultSelected} />
        </div>
    )
}